import React from 'react';
import SectionTitle from '../../components/SectionTitle';
import SingleService from '../../components/Service';

import shapeImg1 from '../../assets/img/service/sv-shape-1.png';
import shapeImg2 from '../../assets/img/service/sv-shape-2.png';
import serviceIconBg1 from '../../assets/img/service/sv-icon-shape-1.png';
import serviceIconBg2 from '../../assets/img/service/sv-icon-shape-2.png';
import serviceIconBg3 from '../../assets/img/service/sv-icon-shape-3.png';
import serviceIconBg4 from '../../assets/img/service/sv-icon-shape-4.png';
import serviceIconBg5 from '../../assets/img/service/sv-icon-shape-5.png';
import serviceIconBg6 from '../../assets/img/service/sv-icon-shape-6.png';

const Service = () => {
  return (
    <div className="service__area service__space service__mlr grey-bg pt-195 pb-70 p-relative">
      <div className="service__shape-1">
        <img src={shapeImg1} alt="Shape" />
      </div>
      <div className="service__shape-2">
        <img src={shapeImg2} alt="Shape" />
      </div>
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div
            className="col-xl-6 col-lg-6 wow animate__fadeInUp"
            data-wow-duration="1.1s"
          >
            <SectionTitle
              sectionClass="service__section-box text-center pb-35 section-title-fixed-width"
              subTitle="Our Expertise"
              Title="Innovative Technology Solutions for Every Business Need"
            />
          </div>
        </div>
        <div className="row">
          {/* Service 1: ERP & CRM Solutions */}
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleService
              itemClass="service__item service__border-1 p-relative fix"
              titleClass="service__title title-color-1"
              btnClass="service__link service__link-color-1"
              serviceIconBg={serviceIconBg1}
              Title="ERP & CRM Solutions"
              Description="Streamline your operations and improve customer relationships with our powerful ERP & CRM solutions tailored to your business."
              btnText="Read More"
              btnURL="services/erp-crm"
            />
          </div>

          {/* Service 2: Inventory Management */}
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleService
              itemClass="service__item service__border-2 p-relative fix"
              titleClass="service__title title-color-2"
              btnClass="service__link service__link-color-2"
              serviceIconBg={serviceIconBg2}
              Title="Inventory Management"
              Description="Optimize your supply chain with real-time inventory tracking and automated stock management solutions."
              btnText="Read More"
              btnURL="services/inventory-management"
            />
          </div>

          {/* Service 3: Mobile App Development */}
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".9s"
          >
            <SingleService
              itemClass="service__item service__border-3 p-relative fix"
              titleClass="service__title title-color-3"
              btnClass="service__link service__link-color-3"
              serviceIconBg={serviceIconBg3}
              Title="Mobile Application Development"
              Description="Deliver seamless experiences to your customers with high-performance mobile applications tailored to your business."
              btnText="Read More"
              btnURL="services/mobile-app-development"
            />
          </div>

          {/* Service 4: Digital Transformation */}
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1s"
          >
            <SingleService
              itemClass="service__item service__border-4 p-relative fix"
              titleClass="service__title title-color-4"
              btnClass="service__link service__link-color-4"
              serviceIconBg={serviceIconBg4}
              Title="Digital Transformation"
              Description="Upgrade legacy systems, automate workflows, and embrace the future with our advanced digital transformation strategies."
              btnText="Read More"
              btnURL="services/digital-transformation"
            />
          </div>

          {/* Service 5: Cloud Solutions */}
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1.2s"
          >
            <SingleService
              itemClass="service__item service__border-5 p-relative fix"
              titleClass="service__title title-color-5"
              btnClass="service__link service__link-color-5"
              serviceIconBg={serviceIconBg5}
              Title="Cloud Solutions"
              Description="Enable remote collaboration and scalability with our secure, cost-effective cloud computing solutions."
              btnText="Read More"
              btnURL="services/cloud-solutions"
            />
          </div>

          {/* Service 6: IT Consulting */}
          <div
            className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay="1.3s"
          >
            <SingleService
              itemClass="service__item service__border-6 p-relative fix"
              titleClass="service__title title-color-6"
              btnClass="service__link service__link-color-6"
              serviceIconBg={serviceIconBg6}
              Title="IT Consulting"
              Description="Leverage expert guidance on technology adoption, IT strategy, and business process optimization."
              btnText="Read More"
              btnURL="services/it-consulting"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
